/* Fortlar – atualização confiável do carrinho lateral */
(function(){
  if(window.__flCart)return;window.__flCart=true;
  var busy=false,queue=null;
  function drawer(){return document.querySelector('cart-drawer');}
  function lineOf(el){
    var rb=el.closest('cart-remove-button');if(rb&&rb.dataset.index)return parseInt(rb.dataset.index,10);
    var inp=el.closest('quantity-input');inp=inp?inp.querySelector('input'):el;
    if(inp){if(inp.dataset.index)return parseInt(inp.dataset.index,10);var m=(inp.id||'').match(/(\d+)$/);if(m)return parseInt(m[1],10);}
    var item=el.closest('[id^="CartDrawer-Item-"]');if(item){var n=item.id.match(/(\d+)$/);if(n)return parseInt(n[1],10);}
    return null;
  }
  function render(json){
    var d=drawer();if(!d||!json.sections)return;
    var html=json.sections['cart-drawer'];
    if(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var nd=doc.querySelector('cart-drawer');var ni=doc.querySelector('.drawer__inner');var oi=d.querySelector('.drawer__inner');
      if(ni&&oi){oi.replaceWith(document.importNode(ni,true));}
      if(nd){d.classList.toggle('is-empty',nd.classList.contains('is-empty'));}
    }
    var bub=json.sections['cart-icon-bubble'];
    if(bub){var bd=new DOMParser().parseFromString(bub,'text/html');var src=bd.querySelector('.shopify-section')||bd.body;var tgt=document.getElementById('cart-icon-bubble');if(tgt&&src)tgt.innerHTML=src.innerHTML;}
    document.dispatchEvent(new CustomEvent('fortlar:cart-updated',{detail:json}));
  }
  function change(line,qty,itemEl){
    if(!line)return;
    if(busy){queue=[line,qty,itemEl];return;}
    busy=true;
    if(itemEl){itemEl.classList.add('fl-cart-updating');if(qty===0)itemEl.classList.add('fl-cart-removing');}
    var d=drawer();if(d)d.classList.add('fl-cart-busy');
    fetch((window.routes&&window.routes.cart_change_url)||'/cart/change',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({line:line,quantity:qty,sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})})
    .then(function(r){return r.json();})
    .then(function(j){if(j&&j.sections){render(j);}else{throw new Error(j&&(j.description||j.message)||'erro');}})
    .catch(function(){if(itemEl)itemEl.classList.remove('fl-cart-updating','fl-cart-removing');alert('Não foi possível atualizar o carrinho. Tente novamente.');})
    .finally(function(){busy=false;var dd=drawer();if(dd)dd.classList.remove('fl-cart-busy');if(queue){var q=queue;queue=null;change(q[0],q[1],q[2]);}});
  }
  document.addEventListener('click',function(e){
    var d=drawer();if(!d||!d.contains(e.target))return;
    var rm=e.target.closest('cart-remove-button');
    var qb=e.target.closest('quantity-input .quantity__button');
    if(!rm&&!qb)return;
    e.preventDefault();e.stopImmediatePropagation();
    var item=e.target.closest('.cart-item');var line=lineOf(e.target);
    if(rm){change(line,0,item);return;}
    var inp=qb.closest('quantity-input').querySelector('input');var cur=parseInt(inp.value,10)||1;
    var nq=qb.name==='plus'?cur+1:cur-1;if(nq<0)nq=0;inp.value=nq;change(line,nq,item);
  },true);
  document.addEventListener('change',function(e){
    var d=drawer();if(!d||!d.contains(e.target)||!e.target.matches('quantity-input input'))return;
    e.stopImmediatePropagation();var v=parseInt(e.target.value,10);if(isNaN(v)||v<0)v=0;change(lineOf(e.target),v,e.target.closest('.cart-item'));
  },true);
})();
